require('../../modules/es6.string.trim');
module.exports = require('../../modules/_core').String.trim;



//////////////////
// WEBPACK FOOTER
// ../~/core-js/library/fn/string/trim.js
// module id = 1207
// module chunks = 1